import images from "./images";

const projects = [
    {
        id: 1,
        image: images.project1,
        title: "Hardwood Installation",
        details: {
            date: "February 2, 2024",
            client: "Residential and Commercial Customers",
            category: "Flooring Installation",
            duration: "Varies based on project size",
            location: "Nationwide Hardwood Flooring Services",
            cost: "Customized pricing based on project requirements",
            leadSpecialist: "John Hardwoodson"
        },
        paragraphs: [
            "Transform your space with our professional hardwood installation services. We provide expert craftsmanship and attention to detail, ensuring a flawless and long-lasting hardwood floor.",
            "Elevate your living space with our hardwood flooring installation services. From traditional to modern styles, we offer a wide range of hardwood options to suit your preferences and enhance the beauty of your home."
        ],
        gallery: [
            images.project1Gallery1,
            images.project1Gallery2,
            images.project1Gallery3,
            images.project1Gallery4,
            images.project1Gallery5,
            images.project1Gallery6
        ],
        challenges: [
            "Precision Measurement and Planning",
            "Subfloor Preparation and Leveling",
            "Seamless Integration with Existing Flooring"
        ],
        solutions: [
            "Professional Installation Techniques",
            "High-Quality Hardwood Selection",
            "Post-Installation Inspection and Maintenance Advice"
        ],
        results: [
            "Beautiful and Durable Hardwood Floors",
            "Enhanced Aesthetic Appeal of Your Space",
            "Long-Term Investment in Your Property"
        ]
    },
    {
        id: 2,
        image: images.project2,
        title: "Bathroom Tiling",
        details: {
            date: "March 10, 2024",
            client: "Residential and Commercial Customers",
            category: "Tile Installation",
            duration: "Depends on project size and tile type",
            location: "Nationwide Tiling Services",
            cost: "Customized pricing based on tile selection and area",
            leadSpecialist: "Jane Smith"
        },
        paragraphs: [
            "Enhance your bathroom with our expert tiling services. We specialize in precise, durable, and aesthetically pleasing tile installations tailored to your style and preferences.",
            "Our bathroom tiling solutions include a variety of tile options and professional installation techniques to ensure waterproof and long-lasting finishes that elevate your space."
        ],
        gallery: [
            images.project2Gallery1,
            images.project2Gallery2,
            images.project2Gallery3,
            images.project2Gallery4,
            images.project2Gallery5,
            images.project2Gallery6
        ],
        challenges: [
            "Surface Preparation and Waterproofing",
            "Precise Tile Alignment and Cutting",
            "Ensuring Grout Durability and Finish"
        ],
        solutions: [
            "Use of High-Quality Waterproof Membranes",
            "Skilled Tile Cutting and Layout Techniques",
            "Grout Sealing and Cleaning Services"
        ],
        results: [
            "Beautiful and Water-Resistant Bathroom Surfaces",
            "Enhanced Design and Functionality",
            "Long-Lasting and Low-Maintenance Tile Work"
        ]
    },
    {
        id: 3,
        image: images.project3,
        title: "Carpet Installation",
        details: {
            date: "April 15, 2024", 
            client: "Residential and Commercial Customers",
            category: "Flooring Installation",
            duration: "Varies based on room size and carpet type",
            location: "Nationwide Carpet Installation Services",
            cost: "Pricing based on carpet quality and area covered",
            leadSpecialist: "Lisa Johnson"
        },
        paragraphs: [
            "Refresh your interiors with our professional carpet installation services. We provide expert fitting to ensure a smooth, comfortable, and visually appealing carpet surface.",
            "From plush residential carpets to durable commercial options, our team guarantees precise installation tailored to your specific requirements and style preferences."
        ],
        gallery: [
            images.project3Gallery1,
            images.project3Gallery2,
            images.project3Gallery3,
            images.project3Gallery4,
            images.project3Gallery5,
            images.project3Gallery6
        ],
        challenges: [
            "Accurate Measurement and Cutting",
            "Seamless Joining of Carpet Sections",
            "Surface Preparation and Underlay Installation"
        ],
        solutions: [
            "Use of Professional Carpet Stretchers",
            "Expert Seam Sealing Techniques",
            "High-Quality Underlay for Comfort and Durability"
        ],
        results: [
            "Smooth, Wrinkle-Free Carpet Surfaces",
            "Enhanced Comfort and Insulation",
            "Long-Lasting and Attractive Flooring"
        ]
    },
    {
        id: 4,
        image: images.project4,
        title: "Deck Paving",
        details: {
            date: "March 10, 2024",
            client: "Homeowners and Commercial Clients",
            category: "Paving Services",
            duration: "Depends on deck size and design complexity",
            location: "Nationwide Deck Paving Services",
            cost: "Customized pricing based on materials and project scope",
            leadSpecialist: "Michael Brown"
        },
        paragraphs: [
            "Enhance your outdoor living space with our professional deck paving services. We specialize in creating durable, stylish decks that complement your home and lifestyle.",
            "Our expert team uses high-quality materials and precise installation techniques to deliver beautiful, long-lasting deck surfaces that withstand weather and wear."
        ],
        gallery: [
            images.project4Gallery1,
            images.project4Gallery2,
            images.project4Gallery3,
            images.project4Gallery4,
            images.project4Gallery5,
            images.project4Gallery6
        ],
        challenges: [
            "Site Preparation and Leveling",
            "Material Selection for Durability",
            "Weather Resistance Considerations"
        ],
        solutions: [
            "Use of Premium Paving Materials",
            "Professional Surface Grading and Drainage",
            "Protective Sealants and Finishes"
        ],
        results: [
            "Attractive and Functional Deck Spaces",
            "Enhanced Outdoor Usability",
            "Long-Term Structural Integrity"
        ]
    },
    {
        id: 5,
        image: images.project5,
        title: "Kitchen Tiling",
        details: {
            date: "April 5, 2024",
            client: "Homeowners and Commercial Kitchens",
            category: "Tile Installation",
            duration: "Depends on kitchen size and tile complexity",
            location: "Nationwide Kitchen Tiling Services",
            cost: "Custom pricing based on tile types and area size",
            leadSpecialist: "Jane Smith"
        },
        paragraphs: [
            "Upgrade your kitchen with our expert tiling services. We offer precise installation of a variety of tile styles to enhance both functionality and aesthetics.",
            "Our skilled specialists ensure durable and water-resistant tiling that complements your kitchen’s design, making cleaning easy and maintaining beauty over time."
        ],
        gallery: [
            images.project5Gallery1,
            images.project5Gallery2,
            images.project5Gallery3,
            images.project5Gallery4,
            images.project5Gallery5,
            images.project5Gallery6
        ],
        challenges: [
            "Surface Preparation and Waterproofing",
            "Precise Tile Alignment and Grouting",
            "Maintaining Aesthetic Consistency"
        ],
        solutions: [
            "Use of High-Quality Adhesives and Grout",
            "Expert Waterproofing Techniques",
            "Customization to Match Kitchen Style"
        ],
        results: [
            "Beautiful and Functional Kitchen Surfaces",
            "Increased Durability and Water Resistance",
            "Enhanced Overall Kitchen Appeal"
        ]
    },
    {
        id: 6,
        image: images.project6,
        title: "Walkway Installation",
        details: {
            date: "March 10, 2024",
            client: "Residential and Commercial Clients",
            category: "Paving Services",
            duration: "Varies by walkway length and design complexity",
            location: "Nationwide Walkway Installation Services",
            cost: "Custom pricing based on materials and design",
            leadSpecialist: "Michael Brown"
        },
        paragraphs: [
            "Enhance your outdoor space with our professional walkway installation services. We create durable, attractive walkways using quality paving materials tailored to your style and needs.",
            "Our experts ensure precise installation and proper drainage to provide walkways that are both functional and visually appealing, improving the overall landscape design."
        ],
        gallery: [
            images.project6Gallery1,
            images.project6Gallery2,
            images.project6Gallery3,
            images.project6Gallery4,
            images.project6Gallery5,
            images.project6Gallery6
        ],
        challenges: [
            "Ground Leveling and Base Preparation",
            "Material Selection for Durability",
            "Integration with Existing Landscape"
        ],
        solutions: [
            "Use of High-Quality Paving Materials",
            "Expert Installation for Long-Term Stability",
            "Custom Designs to Match Client Preferences"
        ],
        results: [
            "Durable and Safe Walkways",
            "Enhanced Outdoor Aesthetic",
            "Increased Property Value"
        ]
    }

];

export default projects;